import React from 'react'

import { Row, Col, Button } from '_zari/core'

import * as Sections from './sections'
import * as Modals from './modals'

const SECTIONS_IDS = {
  ADMINISTRATIVO: 'ADMIN',
  CAMBIO_FECHA_DOCUMENTOS: 'CAMBIO-FEC-DOC',
  COMPANIA_CONFIGURACION: 'COMPANIA-CONFIG',
  CORRECCION_DUPLICADOS: 'CORRECCION-DUP'
}

const DivButton = ({ id, nombre, outline, onClick }) => {
  return (
    <Row className='mb-2'>
      <Col md={12}>
        <Button id={id} outline={outline} onClick={onClick} block>
          {nombre}
        </Button>
      </Col>
    </Row>
  )
}

const MainPage = () => {
  const [activeSection, setActiveSection] = React.useState(SECTIONS_IDS.ADMINISTRATIVO)
  const [mostrarModalPass, setMostrarModalPass] = React.useState(true)

  return (
    <>
      <Row>
        <Col md={2}>
          <DivButton
            id={SECTIONS_IDS.ADMINISTRATIVO}
            nombre='Administrativo'
            outline={activeSection !== SECTIONS_IDS.ADMINISTRATIVO}
            onClick={() => setActiveSection(SECTIONS_IDS.ADMINISTRATIVO)}
          />
          <DivButton
            id={SECTIONS_IDS.COMPANIA_CONFIGURACION}
            nombre='Compania configuracion'
            outline={activeSection !== SECTIONS_IDS.COMPANIA_CONFIGURACION}
            onClick={() => setActiveSection(SECTIONS_IDS.COMPANIA_CONFIGURACION)}
          />
          <DivButton
            id={SECTIONS_IDS.CAMBIO_FECHA_DOCUMENTOS}
            nombre='Cambio fecha documentos'
            outline={activeSection !== SECTIONS_IDS.CAMBIO_FECHA_DOCUMENTOS}
            onClick={() => setActiveSection(SECTIONS_IDS.CAMBIO_FECHA_DOCUMENTOS)}
          />
          <DivButton
            id={SECTIONS_IDS.CORRECCION_DUPLICADOS}
            nombre='Correccion Duplicados'
            outline={activeSection !== SECTIONS_IDS.CORRECCION_DUPLICADOS}
            onClick={() => setActiveSection(SECTIONS_IDS.CORRECCION_DUPLICADOS)}
          />
        </Col>
        <Col md={10}>
          {activeSection === SECTIONS_IDS.ADMINISTRATIVO && <Sections.AdministrativoSection />}
          {activeSection === SECTIONS_IDS.CAMBIO_FECHA_DOCUMENTOS && <Sections.CambioFechaDocumentosSection />}
          {activeSection === SECTIONS_IDS.COMPANIA_CONFIGURACION && <Sections.CompaniaConfiguracionSection />}
          {activeSection === SECTIONS_IDS.CORRECCION_DUPLICADOS && <Sections.CorreccionDuplicadosSection />}
        </Col>
      </Row>
      {mostrarModalPass && (
        <Modals.PasswordModal show={mostrarModalPass} handleClose={() => setMostrarModalPass(false)} />
      )
      }
    </>
  )
}

export default React.memo(MainPage)
